function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.464 7.48535C19.343 16.2353 26.178 23.0703 34.928 24.9493C26.178 26.8282 19.343 33.6633 17.464 42.4132C15.5851 33.6633 8.75005 26.8282 0.00012207 24.9493C8.75005 23.0703 15.5851 16.2353 17.464 7.48535Z",
  fill: "#AF6AF4"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.6699 33.7764C39.6094 38.1513 43.0269 41.5689 47.4019 42.5083C43.0269 43.4478 39.6094 46.8653 38.6699 51.2403C37.7305 46.8653 34.313 43.4478 29.938 42.5083C34.313 41.5689 37.7305 38.1513 38.6699 33.7764Z",
  fill: "#AF6AF4"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.9277 0C35.4645 2.49998 37.4174 4.45285 39.9174 4.98969C37.4174 5.52653 35.4645 7.4794 34.9277 9.97938C34.3908 7.4794 32.438 5.52653 29.938 4.98969C32.438 4.45285 34.3908 2.49998 34.9277 0Z",
  fill: "#AF6AF4"
});
function SvgManageProjectStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageProjectStar);
export default __webpack_public_path__ + "static/media/manageProjectStar.a70cd39c.svg";
export { ForwardRef as ReactComponent };